export function normalizeTastingNotes(
  values?: Array<string | null | undefined> | null,
): string[] {
  if (!values) {
    return [];
  }

  const deduped = new Map<string, string>();

  for (const value of values) {
    const normalized = value?.trim().replace(/\s+/g, " ");
    if (!normalized) {
      continue;
    }

    const key = normalized.toLowerCase();
    if (!deduped.has(key)) {
      deduped.set(key, normalized);
    }
  }

  return Array.from(deduped.values());
}

export function shouldOfferCreateTastingNote(args: {
  searchValue?: string | null;
  selectedValues?: Array<string | null | undefined> | null;
  options?: Array<string | null | undefined> | null;
}): boolean {
  const normalizedSearch = normalizeTastingNotes(
    args.searchValue ? [args.searchValue] : [],
  )[0];

  if (!normalizedSearch) {
    return false;
  }

  const lookupKey = normalizedSearch.toLowerCase();
  const selectedSet = new Set(
    normalizeTastingNotes(args.selectedValues).map((value) => value.toLowerCase()),
  );
  const optionsSet = new Set(
    normalizeTastingNotes(args.options).map((value) => value.toLowerCase()),
  );

  return !selectedSet.has(lookupKey) && !optionsSet.has(lookupKey);
}

export function joinTastingNotes(
  values?: Array<string | null | undefined> | null,
): string {
  return normalizeTastingNotes(values).join(", ");
}
